import { inDateOrder } from './assignment'
import { isUnfiledPile } from './fromProject'
import type { Account, StatementView } from './types'

const LAST = Number.MAX_SAFE_INTEGER

// The strip walks the project the way the map is read: account by account, in the map's lane
// order, each account's statements from the earliest period on. Statements with no account come
// after every account, undated ones after the dated, and pages no statement claims come last of
// all. A statement holding no pages yet has nothing to draw, so it waits out of the strip.
export const statementsInAccountOrder = (
  views: StatementView[],
  accounts: Account[],
): StatementView[] => {
  const laneRank = new Map(
    accounts
      .filter((account) => account.numbers.length === 1)
      .map((account, index) => [account.numbers[0], index]),
  )
  const rankOf = (view: StatementView) => {
    const account = accounts.find(
      (held) => held.id === view.statement.accountId,
    )
    return laneRank.get(account?.numbers[0] ?? '') ?? LAST
  }

  const inStripOrder = (one: StatementView, other: StatementView) => {
    const pileFirst =
      Number(isUnfiledPile(one.statement.id)) -
      Number(isUnfiledPile(other.statement.id))
    if (pileFirst !== 0) return pileFirst
    return rankOf(one) - rankOf(other) || inDateOrder(one, other)
  }

  return views.filter((view) => view.pages.length > 0).sort(inStripOrder)
}
